import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1 className="names">JOEY &amp; NING</h1>
      <p className="subtitle">Are Getting Married</p>
    </header>
  );
};

export default Header;

